var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "menu-nav"
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var href = _ref.href,
          navigate = _ref.navigate,
          isActive = _ref.isActive,
          isExactActive = _ref.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-icon flaticon2-architecture-and-city"
        }), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Dashboard")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/builder"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var href = _ref2.href,
          navigate = _ref2.navigate,
          isActive = _ref2.isActive,
          isExactActive = _ref2.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-icon flaticon2-expand"
        }), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Layout Builder")])])])];
      }
    }])
  }), _vm._m(0), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/vue-bootstrap')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(2), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/alert"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var href = _ref3.href,
          navigate = _ref3.navigate,
          isActive = _ref3.isActive,
          isExactActive = _ref3.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Alert")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/badge"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var href = _ref4.href,
          navigate = _ref4.navigate,
          isActive = _ref4.isActive,
          isExactActive = _ref4.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Badge")])])])];
      }
    }])
  }), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/vue-bootstrap/button')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(3), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(4), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/button"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var href = _ref5.href,
          navigate = _ref5.navigate,
          isActive = _ref5.isActive,
          isExactActive = _ref5.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Button")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/button-group"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var href = _ref6.href,
          navigate = _ref6.navigate,
          isActive = _ref6.isActive,
          isExactActive = _ref6.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Button Group")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/button-toolbar"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var href = _ref7.href,
          navigate = _ref7.navigate,
          isActive = _ref7.isActive,
          isExactActive = _ref7.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Button Toolbar")])])])];
      }
    }])
  })], 1)])]), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/card"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var href = _ref8.href,
          navigate = _ref8.navigate,
          isActive = _ref8.isActive,
          isExactActive = _ref8.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Card")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/carousel"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var href = _ref9.href,
          navigate = _ref9.navigate,
          isActive = _ref9.isActive,
          isExactActive = _ref9.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Carousel")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/collapse"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref0) {
        var href = _ref0.href,
          navigate = _ref0.navigate,
          isActive = _ref0.isActive,
          isExactActive = _ref0.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Collapse")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/dropdown"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref1) {
        var href = _ref1.href,
          navigate = _ref1.navigate,
          isActive = _ref1.isActive,
          isExactActive = _ref1.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Dropdown")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/embed"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var href = _ref10.href,
          navigate = _ref10.navigate,
          isActive = _ref10.isActive,
          isExactActive = _ref10.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Embed")])])])];
      }
    }])
  }), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/vue-bootstrap/form')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(5), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(6), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref11) {
        var href = _ref11.href,
          navigate = _ref11.navigate,
          isActive = _ref11.isActive,
          isExactActive = _ref11.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form-checkbox"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref12) {
        var href = _ref12.href,
          navigate = _ref12.navigate,
          isActive = _ref12.isActive,
          isExactActive = _ref12.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form Checkbox")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form-file"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref13) {
        var href = _ref13.href,
          navigate = _ref13.navigate,
          isActive = _ref13.isActive,
          isExactActive = _ref13.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form File")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form-group"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref14) {
        var href = _ref14.href,
          navigate = _ref14.navigate,
          isActive = _ref14.isActive,
          isExactActive = _ref14.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form Group")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form-input"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref15) {
        var href = _ref15.href,
          navigate = _ref15.navigate,
          isActive = _ref15.isActive,
          isExactActive = _ref15.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form Input")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form-radio"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref16) {
        var href = _ref16.href,
          navigate = _ref16.navigate,
          isActive = _ref16.isActive,
          isExactActive = _ref16.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form Radio")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form-select"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref17) {
        var href = _ref17.href,
          navigate = _ref17.navigate,
          isActive = _ref17.isActive,
          isExactActive = _ref17.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form Select")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/form-textarea"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref18) {
        var href = _ref18.href,
          navigate = _ref18.navigate,
          isActive = _ref18.isActive,
          isExactActive = _ref18.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Form Textarea")])])])];
      }
    }])
  })], 1)])]), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/image"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref19) {
        var href = _ref19.href,
          navigate = _ref19.navigate,
          isActive = _ref19.isActive,
          isExactActive = _ref19.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Image")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/input-group"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref20) {
        var href = _ref20.href,
          navigate = _ref20.navigate,
          isActive = _ref20.isActive,
          isExactActive = _ref20.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Input Group")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/jumbotron"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref21) {
        var href = _ref21.href,
          navigate = _ref21.navigate,
          isActive = _ref21.isActive,
          isExactActive = _ref21.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Jumbotron")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/layout-grid-system"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref22) {
        var href = _ref22.href,
          navigate = _ref22.navigate,
          isActive = _ref22.isActive,
          isExactActive = _ref22.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Layout and Grid System")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/link"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref23) {
        var href = _ref23.href,
          navigate = _ref23.navigate,
          isActive = _ref23.isActive,
          isExactActive = _ref23.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Link")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/list-group"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref24) {
        var href = _ref24.href,
          navigate = _ref24.navigate,
          isActive = _ref24.isActive,
          isExactActive = _ref24.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("List group")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/media"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref25) {
        var href = _ref25.href,
          navigate = _ref25.navigate,
          isActive = _ref25.isActive,
          isExactActive = _ref25.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Media")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/modal"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref26) {
        var href = _ref26.href,
          navigate = _ref26.navigate,
          isActive = _ref26.isActive,
          isExactActive = _ref26.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Modal")])])])];
      }
    }])
  }), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/vue-bootstrap/nav')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(7), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(8), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/nav"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref27) {
        var href = _ref27.href,
          navigate = _ref27.navigate,
          isActive = _ref27.isActive,
          isExactActive = _ref27.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Nav")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/navbar"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref28) {
        var href = _ref28.href,
          navigate = _ref28.navigate,
          isActive = _ref28.isActive,
          isExactActive = _ref28.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Navbar")])])])];
      }
    }])
  })], 1)])]), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/vue-bootstrap/pagination')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(9), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(10), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/pagination"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref29) {
        var href = _ref29.href,
          navigate = _ref29.navigate,
          isActive = _ref29.isActive,
          isExactActive = _ref29.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Pagination")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/pagination-nav"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref30) {
        var href = _ref30.href,
          navigate = _ref30.navigate,
          isActive = _ref30.isActive,
          isExactActive = _ref30.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Pagination Nav")])])])];
      }
    }])
  })], 1)])]), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(11), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(12), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/popover"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref31) {
        var href = _ref31.href,
          navigate = _ref31.navigate,
          isActive = _ref31.isActive,
          isExactActive = _ref31.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Popover")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/toasts"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref32) {
        var href = _ref32.href,
          navigate = _ref32.navigate,
          isActive = _ref32.isActive,
          isExactActive = _ref32.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Toasts")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/tooltip"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref33) {
        var href = _ref33.href,
          navigate = _ref33.navigate,
          isActive = _ref33.isActive,
          isExactActive = _ref33.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Tooltip")])])])];
      }
    }])
  })], 1)])]), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(13), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(14), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/progress"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref34) {
        var href = _ref34.href,
          navigate = _ref34.navigate,
          isActive = _ref34.isActive,
          isExactActive = _ref34.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Progress")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/spinner"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref35) {
        var href = _ref35.href,
          navigate = _ref35.navigate,
          isActive = _ref35.isActive,
          isExactActive = _ref35.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Spinner")])])])];
      }
    }])
  })], 1)])]), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/table"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref36) {
        var href = _ref36.href,
          navigate = _ref36.navigate,
          isActive = _ref36.isActive,
          isExactActive = _ref36.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Table")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vue-bootstrap/tabs"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref37) {
        var href = _ref37.href,
          navigate = _ref37.navigate,
          isActive = _ref37.isActive,
          isExactActive = _ref37.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Tabs")])])])];
      }
    }])
  })], 1)])]), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('vuetify')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(15), _c('div', {
    staticClass: "menu-submenu",
    staticStyle: {
      "display": "none",
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(16), _c('router-link', {
    attrs: {
      "to": "/vuetify/alerts"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref38) {
        var href = _ref38.href,
          navigate = _ref38.navigate,
          isActive = _ref38.isActive,
          isExactActive = _ref38.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Alerts")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/avatars"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref39) {
        var href = _ref39.href,
          navigate = _ref39.navigate,
          isActive = _ref39.isActive,
          isExactActive = _ref39.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Avatars")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/badges"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref40) {
        var href = _ref40.href,
          navigate = _ref40.navigate,
          isActive = _ref40.isActive,
          isExactActive = _ref40.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Badges")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/buttons"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref41) {
        var href = _ref41.href,
          navigate = _ref41.navigate,
          isActive = _ref41.isActive,
          isExactActive = _ref41.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Buttons")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/calendars"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref42) {
        var href = _ref42.href,
          navigate = _ref42.navigate,
          isActive = _ref42.isActive,
          isExactActive = _ref42.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Calendars")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/cards"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref43) {
        var href = _ref43.href,
          navigate = _ref43.navigate,
          isActive = _ref43.isActive,
          isExactActive = _ref43.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Cards")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/chips"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref44) {
        var href = _ref44.href,
          navigate = _ref44.navigate,
          isActive = _ref44.isActive,
          isExactActive = _ref44.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Chips")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/dialog"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref45) {
        var href = _ref45.href,
          navigate = _ref45.navigate,
          isActive = _ref45.isActive,
          isExactActive = _ref45.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Dialog")])])])];
      }
    }])
  }), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(17), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(18), _c('router-link', {
    attrs: {
      "to": "/vuetify/autocompletes"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref46) {
        var href = _ref46.href,
          navigate = _ref46.navigate,
          isActive = _ref46.isActive,
          isExactActive = _ref46.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Autocompletes")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/file-inputs"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref47) {
        var href = _ref47.href,
          navigate = _ref47.navigate,
          isActive = _ref47.isActive,
          isExactActive = _ref47.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("File Inputs")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/forms"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref48) {
        var href = _ref48.href,
          navigate = _ref48.navigate,
          isActive = _ref48.isActive,
          isExactActive = _ref48.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Forms")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/selection-controls"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref49) {
        var href = _ref49.href,
          navigate = _ref49.navigate,
          isActive = _ref49.isActive,
          isExactActive = _ref49.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Selection Controls")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/selects"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref50) {
        var href = _ref50.href,
          navigate = _ref50.navigate,
          isActive = _ref50.isActive,
          isExactActive = _ref50.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Selects")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/textareas"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref51) {
        var href = _ref51.href,
          navigate = _ref51.navigate,
          isActive = _ref51.isActive,
          isExactActive = _ref51.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Textareas")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/text-fields"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref52) {
        var href = _ref52.href,
          navigate = _ref52.navigate,
          isActive = _ref52.isActive,
          isExactActive = _ref52.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Text Fields")])])])];
      }
    }])
  })], 1)])]), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(19), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(20), _c('router-link', {
    attrs: {
      "to": "/vuetify/simple-tables"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref53) {
        var href = _ref53.href,
          navigate = _ref53.navigate,
          isActive = _ref53.isActive,
          isExactActive = _ref53.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Simple Tables")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/data-tables"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref54) {
        var href = _ref54.href,
          navigate = _ref54.navigate,
          isActive = _ref54.isActive,
          isExactActive = _ref54.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Data Tables")])])])];
      }
    }])
  })], 1)])]), _c('router-link', {
    attrs: {
      "to": "/vuetify/tabs"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref55) {
        var href = _ref55.href,
          navigate = _ref55.navigate,
          isActive = _ref55.isActive,
          isExactActive = _ref55.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Tabs")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/timelines"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref56) {
        var href = _ref56.href,
          navigate = _ref56.navigate,
          isActive = _ref56.isActive,
          isExactActive = _ref56.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Timelines")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/tooltips"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref57) {
        var href = _ref57.href,
          navigate = _ref57.navigate,
          isActive = _ref57.isActive,
          isExactActive = _ref57.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Tooltips")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/vuetify/treeview"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref58) {
        var href = _ref58.href,
          navigate = _ref58.navigate,
          isActive = _ref58.isActive,
          isExactActive = _ref58.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Treeview")])])])];
      }
    }])
  })], 1)])]), _vm._m(21), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/error/error')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(22), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(23), _c('router-link', {
    attrs: {
      "to": "/error/error-1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref59) {
        var href = _ref59.href,
          navigate = _ref59.navigate,
          isActive = _ref59.isActive,
          isExactActive = _ref59.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Error 1")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/error/error-2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref60) {
        var href = _ref60.href,
          navigate = _ref60.navigate,
          isActive = _ref60.isActive,
          isExactActive = _ref60.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Error 2")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/error/error-3"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref61) {
        var href = _ref61.href,
          navigate = _ref61.navigate,
          isActive = _ref61.isActive,
          isExactActive = _ref61.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Error 3")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/error/error-4"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref62) {
        var href = _ref62.href,
          navigate = _ref62.navigate,
          isActive = _ref62.isActive,
          isExactActive = _ref62.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Error 4")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/error/error-5"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref63) {
        var href = _ref63.href,
          navigate = _ref63.navigate,
          isActive = _ref63.isActive,
          isExactActive = _ref63.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Error 5")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/error/error-6"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref64) {
        var href = _ref64.href,
          navigate = _ref64.navigate,
          isActive = _ref64.isActive,
          isExactActive = _ref64.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Error 6")])])])];
      }
    }])
  })], 1)])]), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/wizard/wizard')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(24), _c('div', {
    staticClass: "menu-submenu"
  }, [_c('span', {
    staticClass: "menu-arrow"
  }), _c('ul', {
    staticClass: "menu-subnav"
  }, [_vm._m(25), _c('router-link', {
    attrs: {
      "to": "/wizard/wizard-1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref65) {
        var href = _ref65.href,
          navigate = _ref65.navigate,
          isActive = _ref65.isActive,
          isExactActive = _ref65.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Wizard 1")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/wizard/wizard-2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref66) {
        var href = _ref66.href,
          navigate = _ref66.navigate,
          isActive = _ref66.isActive,
          isExactActive = _ref66.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Wizard 2")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/wizard/wizard-3"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref67) {
        var href = _ref67.href,
          navigate = _ref67.navigate,
          isActive = _ref67.isActive,
          isExactActive = _ref67.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Wizard 3")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/wizard/wizard-4"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref68) {
        var href = _ref68.href,
          navigate = _ref68.navigate,
          isActive = _ref68.isActive,
          isExactActive = _ref68.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Wizard 4")])])])];
      }
    }])
  })], 1)])]), _c('li', {
    staticClass: "menu-item menu-item-submenu",
    class: {
      'menu-item-open': _vm.hasActiveChildren('/profile')
    },
    attrs: {
      "aria-haspopup": "true",
      "data-menu-toggle": "hover"
    }
  }, [_vm._m(26), _c('div', {
    staticClass: "menu-submenu menu-submenu-classic menu-submenu-right"
  }, [_c('ul', {
    staticClass: "menu-subnav"
  }, [_c('router-link', {
    attrs: {
      "to": "/profile/profile-1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref69) {
        var href = _ref69.href,
          navigate = _ref69.navigate,
          isActive = _ref69.isActive,
          isExactActive = _ref69.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Profile 1")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/profile/profile-2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref70) {
        var href = _ref70.href,
          navigate = _ref70.navigate,
          isActive = _ref70.isActive,
          isExactActive = _ref70.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Profile 2")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/profile/profile-3"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref71) {
        var href = _ref71.href,
          navigate = _ref71.navigate,
          isActive = _ref71.isActive,
          isExactActive = _ref71.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Profile 3")])])])];
      }
    }])
  }), _c('router-link', {
    attrs: {
      "to": "/profile/profile-4"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref72) {
        var href = _ref72.href,
          navigate = _ref72.navigate,
          isActive = _ref72.isActive,
          isExactActive = _ref72.isExactActive;
        return [_c('li', {
          staticClass: "menu-item",
          class: [isActive && 'menu-item-active', isExactActive && 'menu-item-active'],
          attrs: {
            "aria-haspopup": "true",
            "data-menu-toggle": "hover"
          }
        }, [_c('a', {
          staticClass: "menu-link",
          attrs: {
            "href": href
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "menu-bullet menu-bullet-dot"
        }, [_c('span')]), _c('span', {
          staticClass: "menu-text"
        }, [_vm._v("Profile 4")])])])];
      }
    }])
  })], 1)])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-section"
  }, [_c('h4', {
    staticClass: "menu-text"
  }, [_vm._v("Components")]), _c('i', {
    staticClass: "menu-icon flaticon-more-v2"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-icon flaticon2-digital-marketing"
  }), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Vue Bootstrap")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Vue Bootstrap")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Buttons")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Form")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Navigation")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Pagination")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Notify")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Progress")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-icon flaticon-web"
  }), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Vuetify")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Vuetify")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Forms")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-bullet menu-bullet-dot"
  }, [_c('span')]), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Tables")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-section"
  }, [_c('h4', {
    staticClass: "menu-text"
  }, [_vm._v("Custom")]), _c('i', {
    staticClass: "menu-icon flaticon-more-v2"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-icon flaticon2-list-2"
  }), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Error Pages")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Error Pages")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-icon flaticon2-mail-1"
  }), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Wizard")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "menu-item menu-item-parent",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_c('span', {
    staticClass: "menu-link"
  }, [_c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Wizard")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "menu-link menu-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "menu-icon far fa-user"
  }), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Profile")]), _c('i', {
    staticClass: "menu-arrow"
  })]);
}];
export { render, staticRenderFns };